export function logEvent(type, props) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', type, props);
  }

  if (typeof window !== 'undefined' && window.plausible) {
    window.plausible('event', { ...props, type });
  }
}
